// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"c3a71a48","3932":"ef810e54","5928":"0f4f7fd4","8043":"ef810e54"}[chunkId] + ".chunk.css";
};